export default __webpack_public_path__ + "static/img3-22a74c4841f52f4b8546b7ea5a25a939.jpg";